var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('img',{staticClass:"result",attrs:{"src":"http://wwj.jijiagames.com/web/act/20190312/result.jpg","alt":""}})])}]

export { render, staticRenderFns }